export default {

  refreshInterval: null,

  init() {
    $('.js-ultimo-refresco').html(moment().format('LLL'));
  },

  initRefreshInterval(ms) {
    ms = ms || 15000; // 15 segundos por defecto
    this.refreshInterval = setInterval(() => {
      window.location.reload();
    }, ms)
  },
};
